// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__31cyS","dragIcon":"SortableItem_dragIcon__2ZwdV","disabled":"SortableItem_disabled__1M5cw"};